import {get} from "lodash"

export const postImageErrorHandler = (err) => {
  const msg = get(err, "response.data.message", err.message)
  err.message = `Image failed to upload: ${msg}`

  throw err
}

export const getImageErrorHandler = (err) => {
  const msg = get(err, "response.data.message", err.message)
  err.message = `Image uploaded but failed to retrieve url: ${msg}`

  throw err
}
